import React from "react"
import { storyblokEditable } from "gatsby-source-storyblok"
import TourPrice from "./tourPrice"

const SideTourItem = ({blok}) => {
  // console.log(blok)
  if (!blok.content) return null;

  const content = typeof blok.content === 'string' ? JSON.parse(blok.content) : blok.content;
  const bannerBgImage = content.bannerBgImage?.filename ? content.bannerBgImage : null;
  // console.log(bannerBgImage)

  return (
    <a href={`/${blok.full_slug}`} className="min-h-[150px] cursor-pointer" {...storyblokEditable(blok)} >
      <img className="w-full h-[100px] rounded object-cover" alt={bannerBgImage?.alt} 
      loading="lazy" src={bannerBgImage?.filename || "https://img.freepik.com/free-photo/cherry-blossoms-spring-chureito-pagoda-fuji-mountain-japan_335224-213.jpg"} />
      <div className="px-3 border-l">
        <div className="text-sm mt-4 mb-2">{content.tourSubHeading}</div>
        <div className="font-serif font-bold mb-4">{content.tourTitle}</div>
        <div className="price font-bold my-3"><TourPrice currency={content.currency} price={content.price} /></div>
      </div>
    </a>
  )

}

export default SideTourItem
